<template>
  <v-layout justify-left row wrap>
    <v-flex xs12>
      <v-tabs fixed-tabs show-arrows dark color="grey lighten-1">
        <v-tab v-for="(topic, key) in topics" :key="key" ripple :to="topic.to">
          <div><v-icon small :class="['fas', topic.icon]"></v-icon><span class="hidden-xs-only">&nbsp;&nbsp;{{ topic.title }}</span></div>
        </v-tab>
      </v-tabs>
      <v-parallax src="static/bigstock-Attractive-Aged-Businesswoman--230285287.jpg" height="300">
        <h2>Leadership Development</h2>
      </v-parallax>
      <div class="cta-block">Let us customize <router-link to="/contact">a solution for you</router-link></div>
      <v-card>
        <v-container fluid>
          <v-layout row wrap>
            <h3 class="sub-header">Developing the Leader in You</h3>
            <p>This course helps learners to understand the differences between managers and leaders, and teaches them how to increase their influence with their followers.  Participants will evaluate their attitudes and discover the impact attitudes have on their followers.  Attitudes are magnetic – they either draw people closer or they repel them away.  They will also learn to focus on their strengths, so that they have more positive thoughts and attitudes.  Leaders need emotional composure, and this course will give learners a baseline read of their EQ, so they can develop strategies for how to improve it.</p>
            <h3 class="sub-header">Critical Conversations</h3>
            <p>We can say anything we want or need to say, if we say it thoughtfully and with diplomacy and tact.  This course teaches participants how to engage in conversations when both or all participants have differing opinions, emotions are escalated, and the outcomes are important.  The learners will be exposed to a variety of tools that will enable them to control emotions and keep all parties in dialogue.  There will be a focus on creating safety, so that participants in the conversation can be transparent and share all of their thoughts and feelings.  Once transparency is achieved, the results are better decisions, buy-in, and great results!</p>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'leadership',
  data () {
    return {
      topics: [
        {
          title: 'Business Development / Sales',
          icon: 'fa-university',
          excerpt: 'Offering courses that teach your staff to become better business builders through stronger customer relationships, better performance evaluation and bonded team dynamics.',
          to: '/topics/business'
        },
        {
          title: 'Leadership Development',
          icon: 'fa-hand-point-right',
          excerpt: 'Learn the difference between being a manager and being a leader, and how to talk to people at all levels of the organization in ways that engage and strengthen.',
          to: '/topics/leadership'
        },
        {
          title: 'Team Development',
          icon: 'fa-users',
          excerpt: 'Organizations need to learn how to build cohesive teams if they expect to build a sustainable business enterprise by guaging the members.',
          to: '/topics/team'
        },
        {
          title: 'Management Development',
          icon: 'fa-user-tie',
          excerpt: 'Each manager is as individual in style as they are in personality. Each manager can develop those individual traits to their best advantage.',
          to: '/topics/management'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/topics/Leadership.vue